// import { withParams } from "vuelidate"
// import { req } from "vuelidate/lib/validators/common"
import { helpers } from "vuelidate/lib/validators"
const { req, withParams } = helpers

// const noChinese = regex('noChinese', /[^\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC]/gi)

const noChinese = value => !req(value) || !value.match(/[\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC]/gi)

const hkid = value => !req(value) || validateHKID(value)

const validateHKID = value => {
	if (!value || value.match(/^([A-Z]{1,2})([0-9]{6})([A0-9])$/gi) === null) return false

	const baseValue = 11
	const codes = value.split("")

	// https://computerterminal.blogspot.com/2013/02/hong-kong-id-formula-hkid-number-check.html
	const valToBase36 = code => parseInt(code, 36)
	const valWeighted = (val, idx, arr) => val * (arr.length - idx)
	const addVals = (a, c) => (a += c)
	const total = codes
		.map(valToBase36)
		.map(valWeighted)
		.slice(0, -1)
		.reduce(addVals, 324)

	const remainder = total % baseValue
	const checkDigit = codes.pop()

	if (remainder === 0 && checkDigit === "0") {
		return true
	} else if (remainder === 0 && checkDigit !== "0") {
		return false
	} else if (remainder === 1 && checkDigit === "A") {
		return true
	} else if (remainder === 1 && checkDigit !== "A") {
		return false
	}

	const check = baseValue - remainder

	if (check.toString() !== checkDigit) {
		return false
	}

	return true
}

const minWords = min =>
	withParams({ type: "minWords", min }, value => {
		if (!req(value)) return true
		const words = value
			.split(" ")
			.map(item => item.trim())
			.filter(item => item !== "")

		return words.length >= min
	})

/*
 * ageBetween validator
 *
 * @param {number} defaultMin
 * @param {number} defaultMax
 * @param {object} [rules]
 *
 * rules param is an object with keys that may be truthy on
 * person object. property for each key is 2 number array of
 * min and max values to apply
 */
const ageBetween = (defaultMin, defaultMax, rules, compareDate) =>
	withParams(
		add =>
			function(value, person) {
				let lower = defaultMin !== undefined ? defaultMin : null
				let upper = defaultMax !== undefined ? defaultMax : null
				// console.log('********************************')
				// console.log(JSON.stringify({ lower, upper, rules }, null, 2))
				if (rules && typeof rules === "object") {
					Object.keys(rules).forEach(ruleKey => {
						if (person[ruleKey]) {
							lower = rules[ruleKey][0]
							upper = rules[ruleKey][1]
						}
						// console.log(JSON.stringify({ ruleKey, isApplied: person[ruleKey], rule: rules[ruleKey] }, null, 2))
					})
				} else if (rules && Array.isArray(rules)) {
					rules.forEach(({ conditions, rule: [lowerBound, upperBound] }) => {
						conditions = typeof conditions === "string" ? [conditions] : conditions
						if (conditions.every(e => person[e])) {
							lower = lowerBound
							upper = upperBound
						}
					})
				}

				compareDate = compareDate || new Date()
				if (value === null) return true

				function isDateStringOrDateObject(d) {
					return Boolean(
						d &&
							((typeof d === "string" && d.split(/-|\/|\./).length > 2) ||
								(typeof d === "object" && d.getMonth && typeof d.getMonth === "function"))
					)
				}

				const i18n = {
					day: {
						en: "days",
						"zh-HK": "日"
					},
					month: {
						en: "months",
						"zh-HK": "月"
					},
					year: {
						en: "years",
						"zh-HK": ""
					}
				}
				const locale = this?.$store?.state?.locale || "en"

				function standardizeRange(limit, isUpper) {
					const res =
						limit && typeof limit === "object"
							? { type: Object.keys(limit)[0], value: Object.values(limit)[0] }
							: { type: "year", value: limit }
					if (isUpper) res.value += 1
					return res
				}

				function newDateFromString(value, diff) {
					// value arg must either be a date object or a valid date string e.g. YYYY/MM/DD...
					if (!isDateStringOrDateObject(value)) return

					const year = typeof value === "string" ? parseInt(value.split(/-|\/|\./)[0]) : value.getFullYear()
					const month = typeof value === "string" ? parseInt(value.split(/-|\/|\./)[1]) - 1 : value.getMonth()
					const date = typeof value === "string" ? parseInt(value.split(/-|\/|\./)[2]) : value.getDate()

					return new Date(
						year + (diff && diff.type === "year" ? diff.value : 0),
						month + (diff && diff.type === "month" ? diff.value : 0),
						date + (diff && diff.type === "day" ? diff.value : 0),
						0,
						0,
						0,
						0
					)
				}

				const compareDateLower = newDateFromString(compareDate) >= newDateFromString(value, standardizeRange(lower))
				const compareDateUpper = newDateFromString(compareDate) < newDateFromString(value, standardizeRange(upper, true))

				// console.log(JSON.stringify({
				//   lower,
				//   upper,
				//   compareDateLower,
				//   lowerString: `${newDateFromString(compareDate)} >= ${newDateFromString(value, standardizeRange(lower))}`,
				//   upperString: `${newDateFromString(compareDate)} < ${newDateFromString(value, standardizeRange(upper, true))}`,
				//   compareDateUpper,
				//   sLower: standardizeRange(lower),
				//   sUpper: standardizeRange(upper)
				// }, null, 2))

				add({
					min: {
						...standardizeRange(lower),
						translatedType:
							standardizeRange(lower).type === standardizeRange(upper).type ? "" : i18n[standardizeRange(lower).type][locale]
					}
				})
				add({
					max: {
						...standardizeRange(upper),
						translatedType: i18n[standardizeRange(upper).type][locale]
					}
				})
				add({ type: "ageBetween" })
				return !req(value) || (isDateStringOrDateObject(value) && compareDateLower && compareDateUpper)
			}
	)

export { hkid, minWords, noChinese, ageBetween }
